// PlayerFM - In App Ads Tactic
// Handles episode selection and form management for this specific tactic

document.addEventListener('alpine:init', () => {
  Alpine.data('in_app_ads_player_fm_x_data', () => ({
    // Form data
    formData: {
      episode_id: '',
      release_date: '',
      apple_link: '',
      spotify_link: ''
    },
    
    init() {
      // Load saved configuration from backend
      this.loadSavedConfiguration();
      
      // Use $nextTick to ensure DOM is fully rendered
      this.$nextTick(() => {
        this.initializeEpisodeSelect();
      });
    },

    // Load saved configuration from backend
    loadSavedConfiguration() {
      try {
        const savedDataDiv = this.$refs.savedConfigData;
        if (savedDataDiv && savedDataDiv.dataset.savedConfig) {
          const savedConfig = JSON.parse(savedDataDiv.dataset.savedConfig);
          
          if (savedConfig) {
            // Load episode data
            if (savedConfig.episodes && savedConfig.episodes.length > 0) {
              const savedEpisode = savedConfig.episodes[0]; // Only one episode for PlayerFM
              if (savedEpisode.episode_id) {
                this.formData.episode_id = savedEpisode.episode_id;
                this.formData.release_date = savedEpisode.release_date || '';
                this.formData.apple_link = savedEpisode.apple_link || '';
                this.formData.spotify_link = savedEpisode.spotify_link || '';
                
                // Populate episode select dropdown with saved data
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.populateEpisodeSelect();
                  }, 100);
                });
              }
            }
          }
        }
      } catch (error) {
        console.error('Error loading saved configuration:', error);
      }
    },

    // Populate episode select dropdown with saved data
    populateEpisodeSelect() {
      if (this.formData.episode_id) {
        const selectElement = document.querySelector('select[class*="border-gray-300"]');
        
        if (selectElement) {
          selectElement.value = this.formData.episode_id;
        }
      }
    },
    
    // Episode management
    initializeEpisodeSelect() {
      this.$nextTick(() => {
        const selectElement = document.querySelector('select[class*="border-gray-300"]');
        if (selectElement) {
          // Remove existing event listeners to prevent duplicates
          selectElement.removeEventListener('change', this.createEpisodeChangeHandler());
          // Add new event listener
          selectElement.addEventListener('change', this.createEpisodeChangeHandler());
        } else {
          console.error('Could not find episode select element');
        }
      });
    },

    // Create a change handler for the episode select
    createEpisodeChangeHandler() {
      return (event) => {
        const selectedEpisodeId = event.target.value;
        
        if (selectedEpisodeId) {
          this.handleEpisodeSelection(selectedEpisodeId);
        }
      };
    },

    handleEpisodeSelection(episodeId) {
      if (episodeId) {
        this.formData.episode_id = episodeId;
        
        // Find the selected episode data from the backend episodes
        const selectedEpisode = this.findEpisodeById(episodeId);
        
        if (selectedEpisode) {
          // Handle pub_date
          if (selectedEpisode.pub_date) {
            const formattedDate = this.formatDate(selectedEpisode.pub_date);
            this.formData.release_date = formattedDate;
          } else {
            this.formData.release_date = 'Release date not available';
          }
          
          // Handle distribution platforms (Apple and Spotify links)
          if (selectedEpisode.distribution_platforms) {
            const platforms = selectedEpisode.distribution_platforms;
            
            // Set Apple link using itunes_url key
            if (platforms.itunes_url) {
              this.formData.apple_link = platforms.itunes_url;
            } else {
              this.formData.apple_link = '';
            }
            
            // Set Spotify link using spotify_url key
            if (platforms.spotify_url) {
              this.formData.spotify_link = platforms.spotify_url;
            } else {
              this.formData.spotify_link = '';
            }
          } else {
            this.formData.apple_link = '';
            this.formData.spotify_link = '';
          }
        }
      }
    },

    // Find episode by ID from the backend data
    findEpisodeById(episodeId) {
      // Get episodes data from the global window object
      let episodesData = window.episodesData || [];
      
      if (!episodesData || episodesData.length === 0) {
        return null;
      }
      
      const foundEpisode = episodesData.find(episode => episode.id == episodeId);
      return foundEpisode;
    },

    // Format date for display
    formatDate(dateString) {
      if (!dateString) return 'Date not available';
      
      try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return 'Invalid date';
        
        return date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });
      } catch (error) {
        console.error('Error formatting date:', error);
        return 'Date not available';
      }
    },

    // Save as draft
    saveAsDraft() {
      try {
        // Validation - ensure exactly 1 episode is selected
        if (!this.formData.episode_id || this.formData.episode_id === '') {
          alert('Please select exactly one episode to highlight.');
          return;
        }
        
        // Prepare data for submission
        const formDataToSubmit = {
          episodes: [{
            episode_id: this.formData.episode_id,
            release_date: this.formData.release_date,
            apple_link: this.formData.apple_link,
            spotify_link: this.formData.spotify_link
          }]
        };
        
        // Get the save as draft link from the routes template
        const routesTemplate = this.$refs.routes;
        const saveAsDraftLink = routesTemplate?.dataset?.saveAsDraftLink;
        
        if (!saveAsDraftLink) {
          alert('Save as draft link not found. Please refresh the page and try again.');
          return;
        }
        
        // Create a hidden form and submit it
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = saveAsDraftLink;
        
        // Add CSRF token
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        if (csrfToken) {
          const csrfInput = document.createElement('input');
          csrfInput.type = 'hidden';
          csrfInput.name = 'authenticity_token';
          csrfInput.value = csrfToken;
          form.appendChild(csrfInput);
        }
        
        // Add method override for PATCH
        const methodInput = document.createElement('input');
        methodInput.type = 'hidden';
        methodInput.name = '_method';
        methodInput.value = 'PATCH';
        form.appendChild(methodInput);
        
        // Add form data as JSON
        const formDataInput = document.createElement('input');
        formDataInput.type = 'hidden';
        formDataInput.name = 'form_data';
        formDataInput.value = JSON.stringify(formDataToSubmit);
        form.appendChild(formDataInput);
        
        // Add to DOM and submit
        document.body.appendChild(form);
        form.submit();
      } catch (error) {
        alert('Error saving as draft. Please try again.');
      }
    },

    // Save form configuration
    saveForm() {
      try {
        // Validation - ensure exactly 1 episode is selected
        if (!this.formData.episode_id || this.formData.episode_id === '') {
          alert('Please select exactly one episode to highlight.');
          return;
        }
        
        // Prepare data for submission
        const formDataToSubmit = {
          episodes: [{
            episode_id: this.formData.episode_id,
            release_date: this.formData.release_date,
            apple_link: this.formData.apple_link,
            spotify_link: this.formData.spotify_link
          }]
        };
        
        // Get the submit link from the routes template
        const routesTemplate = this.$refs.routes;
        const submitLink = routesTemplate?.dataset?.submitLink;
        
        if (!submitLink) {
          alert('Submit link not found. Please refresh the page and try again.');
          return;
        }
        
        // Create a hidden form and submit it
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = submitLink;
        
        // Add CSRF token
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        if (csrfToken) {
          const csrfInput = document.createElement('input');
          csrfInput.type = 'hidden';
          csrfInput.name = 'authenticity_token';
          csrfInput.value = csrfToken;
          form.appendChild(csrfInput);
        }
        
        // Add method override for PATCH
        const methodInput = document.createElement('input');
        methodInput.type = 'hidden';
        methodInput.name = '_method';
        methodInput.value = 'PATCH';
        form.appendChild(methodInput);
        
        // Add form data as JSON
        const formDataInput = document.createElement('input');
        formDataInput.type = 'hidden';
        formDataInput.name = 'form_data';
        formDataInput.value = JSON.stringify(formDataToSubmit);
        form.appendChild(formDataInput);
        
        // Add to DOM and submit
        document.body.appendChild(form);
        form.submit();
      } catch (error) {
        alert('Error saving configuration. Please try again.');
      }
    }
  }));
});
